module.exports = __webpack_public_path__ + "static/dashboard-982fe3768ab2eb37d6e63e2fc52a15cd.mp4";